module.exports = __webpack_public_path__ + "img/logo-1.33ce462b.png";